import { useMemo } from 'react'

import { Text } from '@wartek-id/text-v1'

import {
  Table,
  TableBody,
  TableRow,
  TableHeader,
  TableHeaderItem,
  TableRowItem,
  TableShimmer,
} from 'app/KinerjaShared/components/Table'
import { assetUrl } from 'utils/url'
import { PerencanaanStatusBadge } from 'app/KinerjaGpkPage/components/PerencanaanStatusBadge'

import type { KinerjaStatusGpk } from 'types/kinerja-gpk'

type PerencanaanTableProps = {
  isLoading?: boolean
  items: Array<PerencanaanTableItem>
  statusFilter?: Array<KinerjaStatusGpk | 'ALL'>
  emptyStateMessage?: string
  renderAction?: (item: PerencanaanTableItem) => React.ReactNode
}

export type PerencanaanTableItem = {
  id: string
  name: string
  status: KinerjaStatusGpk
  ptkId: string
}

export function PerencanaanTable({
  isLoading,
  items = [],
  statusFilter = ['ALL'],
  emptyStateMessage = 'Tidak ada data perencanaan',
  renderAction,
}: PerencanaanTableProps) {
  const filteredItems = useMemo(() => {
    const hasFilter = statusFilter.length > 0 && !statusFilter.includes('ALL')
    if (!hasFilter) return items

    return items.filter((item) => {
      return statusFilter.includes(item.status)
    })
  }, [items, statusFilter])

  const isEmpty = filteredItems.length === 0

  return (
    <Table rounded withOuterBorder={false} className="bg-white">
      <TableHeader>
        <TableHeaderItem>Nama</TableHeaderItem>
        <TableHeaderItem>Status</TableHeaderItem>
        <TableHeaderItem></TableHeaderItem>
      </TableHeader>
      <TableBody>
        {isLoading ? (
          <TableShimmer columns={3} rows={5} />
        ) : isEmpty ? (
          <TableRow>
            <TableRowItem colSpan={3}>
              <div className="text-center mt-12 mb-16 max-w-lg mx-auto">
                <img
                  src={assetUrl('/illustrations/img-empty-search-result.png')}
                  alt=""
                  width="120"
                  height="120"
                  className="h-30 w-30 mb-6 mx-auto"
                />

                <Text color="subdued">{emptyStateMessage}</Text>
              </div>
            </TableRowItem>
          </TableRow>
        ) : (
          filteredItems.map((item) => (
            <TableRow key={item.id}>
              <TableRowItem className="w-80">
                <Text
                  variant="body"
                  as="span"
                  className="overflow-wrap-anywhere"
                >
                  {item.name}
                </Text>
              </TableRowItem>
              <TableRowItem>
                <PerencanaanStatusBadge status={item.status} />
              </TableRowItem>
              <TableRowItem className="text-right flex justify-end">
                {renderAction?.(item)}
              </TableRowItem>
            </TableRow>
          ))
        )}
      </TableBody>
    </Table>
  )
}
